import React from "react";
import { translate } from "../../../../../../common/providers";
import styles from "../Row.module.css";

const HeaderRow = () => (
	<div className={styles.header}>
		<div>{translate("dsi.feature-management.table.header.feature-name")}</div>
		<div>{translate("dsi.feature-management.table.header.description")}</div>
		<div>{translate("dsi.feature-management.table.header.active")}</div>
	</div>
);

export default HeaderRow;
